/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;


if($('body').hasClass('template-search')  || $('body').hasClass('template-collection') || $('body').hasClass('template-collection-byob')){
  console.log('test');
  // INFINITE COLLECTION
  var pInfScrLoading = false;
  var pInfScrDelay = 20;
  
  function pInfScrExecute() {
    var loadingImage;
    pInfScrNode = $('.product-list__inner').find('.more');	        
    // removeing this condition && pInfScrNode.css('display') != 'none'
    if(!pInfScrLoading && pInfScrNode.length > 0) {
      pInfScrURL = $('.product-list__inner').find('.more a').attr("href");
      $('.product-list').append('<img src="https://cdn.shopify.com/s/files/1/0529/2746/3613/files/loader.gif?v=1755664357" class="loading" style="display:block; margin:auto;" />');
      $.ajax({
        type: 'GET',
        url: pInfScrURL,
        beforeSend: function() {
          pInfScrLoading = true;
          loadingImage = pInfScrNode.clone().empty().append('');
          loadingImage.insertAfter(pInfScrNode);
          pInfScrNode.hide();
          
          console.log('loading...');
        },
        success: function(data) {
          // remove loading feedback
          pInfScrNode.next().remove();
          var filteredData = $(data).find(".product-list__inner");
          // filteredData.attr('data-gridview',$('.grid_view_selector .view_wp.active').attr('data-gridview'));
          $('.product-list__inner').find('.more').before(filteredData.html());
          $('.product-list__inner').find('.more:not(:last-child)').remove();
          if(filteredData.find('.more').length > 0){
            $('.product-list__inner').find('.more').html(filteredData.find('.more').html());
          }else{
            $('.product-list__inner').find('.more').remove();
          }
          
          
          loadingImage.remove();	              
          $('.product-list').find('.loading').remove();
          pInfScrLoading = false;

          var $newSliders = $('.product-item__media-slider-items_list').not('.slick-initialized'); // only untouched sliders
          $newSliders.slick({
            slidesToShow: 1,
            arrows: false,
            dots: true,
            infinite: false
          });

          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
          try {
            if (typeof iWish !== 'undefined' ){
                iWish.checkIwishColl();
            }
          } catch (error) {
            console.log(error);
          }
        },
        dataType: "html"
      });
    }
  }
  $(document).ready(function () {
    $(window).scroll(function(){
      // if( $(document).height() - 800 > $(document).scrollTop() + $(window).height() ) {
      if( $('product-list.product-facet__product-list').height() - 400 < $(document).scrollTop()) {
        $.doTimeout( 'scroll', pInfScrDelay, pInfScrExecute);
        pInfScrDelay = 20;
      }
    });
  });
}

(function ($) {
  var cartMutation = /\/cart\/(add|change|update|clear)/;

  function disableCheckout() {
    $('.gokwik-checkout button').prop('disabled', true).addClass('disabled');
  }

  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (cartMutation.test(url)) disableCheckout();
    return origFetch.apply(this, arguments);
  };
})(jQuery);

$(document).ready(function(){

  if(window.location.hash.indexOf('#opencartdrawer') > -1) {
    document.getElementById('mini-cart').open = true;
    const url = window.location.href.replace("#opencartdrawer", "");
    history.replaceState(null, null, url);
  }

  
  $('body').on('click', '.product-meta_accordion-item_title', function (e) {
    $(this).toggleClass('active');
    $(this).next('.product-meta_accordion-item_content').slideToggle();
  
    // Toggle aria-expanded attribute
    var isExpanded = $(this).attr('aria-expanded') === 'true';
    $(this).attr('aria-expanded', !isExpanded);
  });

  // $('body').on('click','.hasgiftbox_wrapper [type="checkbox"]', function(){
  //   if($(this).is(':checked')){
  //     $(this).closest('.hasgiftbox_wrapper').find('.notebox_wrapper').slideToggle();
  //   }else{
  //     $(this).closest('.hasgiftbox_wrapper').find('.notebox_wrapper').slideToggle().find('#giftnote_message').val('').trigger('change');
  //   }
    
  // });

  $('body').on('change','.hasgiftbox_wrapper #giftbox', function(){
    var _this = this;
    if($(_this).is(':checked')){
      var giftnote = {
        "Has gift": "Yes"
      };
    }else{
      var giftnote = {
        "Has gift": null,
        "Gift note": null
      };
      $(this).closest('.hasgiftbox_wrapper').find('.notebox_wrapper #giftnote_message').val('');
    }
    fetch(`${window.themeVariables.routes.cartUrl}/update.js`, {
      body: JSON.stringify({
        attributes: giftnote
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then(response => response.json())
    .then(cartContent => {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:updated", {
          bubbles: true,
          detail: { cart: cartContent }
        })
      );
    });
    $(this).closest('.hasgiftbox_wrapper').find('.notebox_wrapper').slideToggle();
  });

  $('body').on('change','.hasgiftbox_wrapper #giftnote_message', function(){
    var _this = this;
    console.log('clickkedddd');
    fetch(`${window.themeVariables.routes.cartUrl}/update.js`, {
      body: JSON.stringify({
        attributes: {
          "Gift note": _this.value
        }
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then(response => response.json())
    .then(cartContent => {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:updated", {
          bubbles: true,
          detail: { cart: cartContent }
        })
      );
    });
  });

  $('body').on('change','.notebox_wrapper [name="packaging_type"]', function(){
    var _this = this;
    var msg = $(_this).closest('.packaging_item').find('.type_msg').text();
    $(this).closest('.notebox_wrapper').find('#giftnote_message').val(msg).trigger('change');
    fetch(`${window.themeVariables.routes.cartUrl}/update.js`, {
      body: JSON.stringify({
        attributes: {
          "Packaging type": _this.value
        }
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then(response => response.json())
    .then(cartContent => {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:updated", {
          bubbles: true,
          detail: { cart: cartContent }
        })
      );
    });
  });

  $('body').on('click','.packaging_types .block_header', function(){
    $(this).toggleClass('active');
    $(this).closest('.packaging_types').find('.type_item_wrapper').slideToggle();
  });
  

  $('body').on('change', '.sustainability-newsletter-input__check', function() {
    const $parent = $(this).closest('form'); // or change to your actual parent container
    const $button = $parent.find('.sustainability-newsletter-submit-button');

    if ($(this).is(':checked')) {
      console.log('✅ Checkbox is checked');
      $button.removeAttr('disabled');
    } else {
      console.log('❌ Checkbox is unchecked');
      $button.attr('disabled', 'disabled');
    }
  });

  $('.product-item__media-slider-items_list').slick({
    slidesToShow: 1,
    arrows: false,
    dots: true,
    infinite: false,
  });

  $('.product-item__label-list').each(function () {
    const $list = $(this);
    const $labels = $list.find('.label');
    let currentIndex = 0;

    function switchActive() {
      $labels.removeClass('active');
      $labels.eq(currentIndex).addClass('active');

      currentIndex++;
      if (currentIndex >= $labels.length) {
        currentIndex = 0;
      }
    }

    // initial run
    switchActive();

    // individual interval for each list
    setInterval(switchActive, 2000);

  });
  $('.product-media__label-list').each(function () {
    const $list = $(this);
    const $labels = $list.find('.label');
    let currentIndex = 0;

    function switchActive() {
      $labels.removeClass('active');
      $labels.eq(currentIndex).addClass('active');

      currentIndex++;
      if (currentIndex >= $labels.length) {
        currentIndex = 0;
      }
    }

    // initial run
    switchActive();

    // individual interval for each list
    setInterval(switchActive, 5000);

  });

  $('body').on('click', '.mini-cart-recently-viewed_product-list_title', function (e) {
   $(this).next('.mini-cart-recently-viewed_product-list_content').slideToggle(); 
  });
});


// function addFreeProduct(event, cart) {
//   const settings = window.themeVariables?.settings;
//   if (!settings) return;

//   const freeProductId1 = settings?.free_item1?.variants?.[0]?.id;
//   const milestone1 = parseInt(settings?.price_threshhold1 || "0") * 100;

//   const freeProductId2 = settings?.free_item2?.variants?.[0]?.id;
//   const milestone2 = parseInt(settings?.price_threshhold2 || "0") * 100;

//   var total = cart.total_price;

//   if(settings.free_gift_based_on == 'free_gift_discounted_price') {
//     var total = cart.total_price;
//   }else if(settings.free_gift_based_on == 'free_gift_non_discounted_price'){
//     var total = cart.original_total_price;
//   }
//   var line1 = -1;
//   var line2 = -1;

//   line1 = cart.items.findIndex(item => item.variant_id === freeProductId1);
//   var line_key_1 = cart.items[line1];
  
//   line2 = cart.items.findIndex(item => item.variant_id === freeProductId2);
//   var line_key_2 = cart.items[line2];

//   var items = [];
//   var randomId = Math.random().toString(36).substring(2, 12);
  
//   if ((total > milestone1 && line1 === -1) && freeProductId1) {
//     items.push({
//       quantity: 1,
//       id: freeProductId1,
//       properties: {
//         '_type': 'free_gift',
//       }
//     })
//   }

//   if ((total >= milestone2 && line2 === -1 && line1 !== -1) && freeProductId2) {
//     items.push({
//       quantity: 1,
//       id: freeProductId2,
//       properties: {
//         '_type': 'free_gift',
//       }
//     })
//   }
//   if(items.length > 0){
//     $.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       async: false,
//       data: {items},
//       dataType: 'json',
//       error: function(jqXHR, textStatus, errorThrown){
//         var response = $.parseJSON(jqXHR.responseText);
//         console.log('Free Gift Error',response.description);
//       },
//       success: function() {
//         console.log('success');
//         refreshCart();

//         $('#free-gift-added-popover-1').show();
//         setTimeout(function() {
//           $('#free-gift-added-popover-1').hide();
//         }, 2000);
//       }
//     });
//   }

//   var updateData = {};

//   console.log('line_key_1',line_key_1);
//   if (total <= milestone1 && line1 !== -1) {
//     updateData[line_key_1.key] = 0;    
//   }
//   if (total < milestone2 && line2 !== -1) {
//     updateData[line_key_2.key] = 0;    
//   }

//   if (Object.keys(updateData).length > 0) {
//      $.ajax({
//       type: 'POST',
//       url: '/cart/update.js',
//       data: {
//         updates: updateData
//       },
//       dataType: 'json',
//       async:false,
//       success: function(data) {                
//         console.log('sucess');
//         refreshCart()
//       },
//       error: function (jqXHR, textStatus, errorThrown) {
//         console.log(jqXHR);
//       }
//     });
//   }

//   function refreshCart() {
//     if (document.body.classList.contains("template-cart")) {
//       location.reload();
//     }else{  
//       $.getJSON("/cart.js", function (cart) {
//         document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
//           bubbles: true,
//           detail: { cart }
//         })); 
//       });
//     }
//   }
// }

function refreshCart() {
  if (document.body.classList.contains("template-cart")) {
    location.reload();
  } else {
    $.getJSON("/cart.js", function (cart) {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: { cart }
        })
      );
    });
  }
}

function addFreeProducts(cart) {
  const settings = window.themeVariables?.settings;
  if (!settings) return;

  const freeProductId1 = settings?.free_item1?.variants?.[0]?.id;
  const freeProductId2 = settings?.free_item2?.variants?.[0]?.id;

  const milestone1 = parseInt(settings?.price_threshhold1 || "0") * 100;
  const milestone2 = parseInt(settings?.price_threshhold2 || "0") * 100;

  let total = settings.free_gift_based_on === "free_gift_non_discounted_price"
    ? cart.original_total_price
    : cart.total_price;

  const line1 = cart.items.findIndex(item => item.variant_id === freeProductId1);
  const line2 = cart.items.findIndex(item => item.variant_id === freeProductId2);

  const items = [];

  if (total > milestone1 && line1 === -1 && freeProductId1) {
    items.push({
      id: freeProductId1,
      quantity: 1,
      properties: {
        "_type": "free_gift"
      }
    });
  }

  if (total >= milestone2 && line2 === -1 && line1 !== -1 && freeProductId2) {
    items.push({
      id: freeProductId2,
      quantity: 1,
      properties: {
        "_type": "free_gift"
      }
    });
  }

  if (!items.length) return;

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: { items },
    dataType: "json",
    async: false,
    success: function () {
      refreshCart();

      $("#free-gift-added-popover-1").show();
      setTimeout(function () {
        $("#free-gift-added-popover-1").hide();
      }, 2000);
    },
    error: function (jqXHR) {
      const response = $.parseJSON(jqXHR.responseText);
      console.log("Free Gift Error", response.description);
    }
  });
}

function removeFreeProducts(cart) {
  const settings = window.themeVariables?.settings;
  if (!settings) return;

  const freeProductId1 = settings?.free_item1?.variants?.[0]?.id;
  const freeProductId2 = settings?.free_item2?.variants?.[0]?.id;

  const milestone1 = parseInt(settings?.price_threshhold1 || "0") * 100;
  const milestone2 = parseInt(settings?.price_threshhold2 || "0") * 100;

  let total = settings.free_gift_based_on === "free_gift_non_discounted_price"
    ? cart.original_total_price
    : cart.total_price;

  const line1 = cart.items.findIndex(item => item.variant_id === freeProductId1);
  const line2 = cart.items.findIndex(item => item.variant_id === freeProductId2);

  const updateData = {};

  if (line1 !== -1 && total <= milestone1) {
    updateData[cart.items[line1].key] = 0;
  }

  if (line2 !== -1 && total < milestone2) {
    updateData[cart.items[line2].key] = 0;
  }

  if (Object.keys(updateData).length === 0) return;

  $.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: {
      updates: updateData
    },
    dataType: "json",
    async: false,
    success: function () {
      refreshCart();
    },
    error: function (jqXHR) {
      console.log(jqXHR);
    }
  });
}

$(document).on('click', '.free-gift-claim__button', function () {
  const variantId = $(this).data('variant-id');
  const $button = $(this);

  $button.prop('disabled', true).attr('aria-busy', 'true').addClass('is-loading');
  $('.free-gift-claim__button').attr('disabled', true);

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: {
      items: [{
        id: variantId,
        quantity: 1,
        properties: {
          '_type': 'free_gift'
        }
      }]
    },
    success: function () {
      refreshCart();
      $("#free-gift-added-popover-1").show();
      setTimeout(function () {
        $("#free-gift-added-popover-1").hide();
      }, 2000);
    },
    error: function (jqXHR) {
      const response = $.parseJSON(jqXHR.responseText);
      console.log('Free Gift Error:', response.description);
    },
    complete: function () {
      $button.prop('disabled', false).removeAttr('aria-busy').removeClass('is-loading');
    }
  });
});

document.addEventListener('cart:refresh', function(event) {
  console.log('event',event);
  var cart = event.detail.cart; // Get the updated content of the cart
  removeFreeProducts(cart);
  if(window.themeVariables.settings.free_gift_autoadd == true){
    addFreeProduct(cart);
  }
});


$(document).ready(function(){
  function existingDiscounts(){
    const discountCodes = [];
    const discountPills = $('.cart-cart-coupon_offer-popover').find('.applied_coupon-item');
    for (const pill of discountPills) {
      if (typeof $(pill).attr('data-discount-code') === 'string') {
        discountCodes.push($(pill).attr('data-discount-code'));
      }
    }
    return discountCodes;
  }

  function applied_code(discountCodeValue, _this, sectionId){
    console.log('0000',discountCodeValue, _this, sectionId)
    var existingDiscountsValue = existingDiscounts();
    if (existingDiscountsValue.includes(discountCodeValue)) return;
    console.log('111111111111111')
    
    $(_this).attr("disabled","disabled");
    $(_this).attr("loading","loading");

    async function getupdatedata(){     
      let response = await fetch(`${window.themeVariables.routes.cart_update_url}.js`, {
        method: "POST", // HTTP method (GET, POST, PUT, DELETE, etc.)
        headers : {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          discount: [...existingDiscountsValue, discountCodeValue].join(','),
          sections: [sectionId]
        })
      });
      const data = await response.json();
      return data;
    }
    getupdatedata().then(data => {
      console.log(data);
      if (data.discount_codes.find((/** @type {{ code: string; applicable: boolean; }} */ discount) => {
          return discount.code === discountCodeValue && discount.applicable === false;
        })
      ) {
        $(_this).removeAttr('disabled');                                    
        $(_this).removeAttr('loading'); 
        $(_this).removeClass('loading');
        $('.cart-offer-coupon_applied-message').append(`<div id="applied_code_error" class="applied_code_error text--xsmall">This discount code cannot be applied to your cart</div>`);
        setTimeout(function(){
          $('.applied_code_error').remove();
        },2000);
        return;
      }
      
      // const newHtml = data.sections[sectionId];
      // const parsedHtml = new DOMParser().parseFromString(newHtml, 'text/html');
      // $('.mini-cart__drawer-footer').html($(parsedHtml).find('.mini-cart__drawer-footer').html());
      // $('#coupon-offers').html($(parsedHtml).find('#coupon-offers').html());
      // $(_this).removeClass('loading');
      $.getJSON("/cart.js", function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: { cart }
        })); 
      });
    });
  }
  

  $('body').on('keyup','.cart-offer-coupon_input-field', function(){
    if($(this).val() != ''){
     $(this).closest('.cart-offer-coupon_input').find('.cart-offer-coupon_apply-button').addClass('active'); 
    }else{
     $(this).closest('.cart-offer-coupon_input').find('.cart-offer-coupon_apply-button').removeClass('active');
    }    
  });

  $('body').on('click','.cart-offer-coupon_apply-button.active', function(){
    var _this  = this;
    var discountCodeValue = $(this).closest('.cart-offer-coupon_input').find('.cart-offer-coupon_input-field').val();
    var sectionId = $(_this).closest('cart-drawer').attr('section');
    if(discountCodeValue == ''){
      _this.closest('.cart-offer-coupon_input').after('<p class="offer_input_err">Please enter any code above.</p>');
      return;
    }
    $(_this).attr("disabled","disabled");
    $(_this).attr("loading","loading");

    $('#applied_code_error').remove();
    applied_code(discountCodeValue, _this, sectionId);
  });

  $('body').on('click','.coupon_offer-item_code-copy', function(){
    var _this  = this;
    var discountCodeValue = $(this).attr('coupon');
    var sectionId = $(_this).closest('cart-drawer').attr('section');

    $(_this).removeAttr('disabled');                                    
    $(_this).removeAttr('loading'); 
    $(_this).removeClass('loading');

    $('#applied_code_error').remove();
    applied_code(discountCodeValue, _this, sectionId);
  });

  $('body').on('click','[data-removecode]', function(){
    var _this  = this;
    console.log('hhiiihi')
    var sectionId = $(this).closest('cart-drawer').attr('section');
    var discountCodeValue = $(this).closest('.applied_coupon-item').attr('data-discount-code');
    var existingDiscountsValue = existingDiscounts();
    console.log('existingDiscountsValue:', existingDiscountsValue);

    $(_this).attr("disabled","disabled");
    $(_this).attr("loading","loading");
    
    const index = existingDiscountsValue.indexOf(discountCodeValue);
    if (index === -1) return;

    existingDiscountsValue.splice(index, 1);
    
    async function getupdatedata(){     
      let response = await fetch(`${window.themeVariables.routes.cart_update_url}.js`, {
        method: "POST", // HTTP method (GET, POST, PUT, DELETE, etc.)
        headers : {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ 
          discount: existingDiscountsValue.join(','),
          sections: [sectionId]
        })
      });
      const data = await response.json();
      return data;
    }
    getupdatedata().then(data => {
      console.log(data);
      // const newHtml = data.sections[sectionId];
      // const parsedHtml = new DOMParser().parseFromString(newHtml, 'text/html');
      // console.log(parsedHtml);
      // $('.mini-cart__drawer-footer').html($(parsedHtml).find('.mini-cart__drawer-footer').html());
      // $('#coupon-offers').html($(parsedHtml).find('#coupon-offers').html());

      $(_this).removeAttr('disabled');                                    
      $(_this).removeAttr('loading'); 
      $(_this).removeClass('loading');
      
      $.getJSON("/cart.js", function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: { cart }
        })); 
      });
    });
  });

  // Show / hide arrow on scroll
  $(window).on('scroll', function () {
    if ($(this).scrollTop() > 200) {
      $('.top-arrow').addClass('show');
    } else {
      $('.top-arrow').removeClass('show');
    }
  });

  // Scroll to top on click
  $('.top-arrow').on('click', function () {
    $('html, body').animate({ scrollTop: 0 }, 600);
  });

  if($('[createCustomerForm]').length > 0){
   $('body').on('submit','[createCustomerForm]', function (e) {
      e.preventDefault(); // Prevent form submission
       var _this = $(this);
       var formtag = _this.attr('data-tag');
      _this.find('.banner--success,.banner--error').hide();
      const phone = '91'+_this.find('[data-phone-field]').val();
  
      $.ajax({
        url: "https://dev.d2cbox.com/shopify/api/v1/create_customer/",
        method: "POST",
        contentType:"application/json",
        headers: {
          "Authorization": "c449f210bc654d68bf834d49ea17298e"
        },
        data: JSON.stringify({
          phone: phone,
          tag: formtag
        }),
        success: function (response) {
          console.log(response);
          if(response.status == 1){
            _this.find('.banner--success .banner__content').html(response.message);
            _this.find('.banner--success').show();  
          }else{
            _this.find('.banner--error .banner__content').html(response.message);
            _this.find('.banner--error').show();
          }
          _this.find('[type="submit"]').attr('aria-busy', 'false');
        },
        error: function (xhr, status, error) {
          console.log(xhr, status, error);
          _this.find('.banner--error').show().find('.banner__content').html(xhr.responseJSON.detail);
          _this.find('[type="submit"]').attr('aria-busy', 'false');
        }
      });
                   
    }); 
  }  

  $('body').on('click','.policy_popup_button', function(){
    $('.policy_popup').removeClass('active');
    $('body').addClass('lock-all');
    $(this).closest('.shipping-img').find('.policy_popup').addClass('active');
  });

  $('body').on('click','.policy_popup .close-btn', function(){
    $('.policy_popup').removeClass('active');
    $('body').removeClass('lock-all');
  });

  // SEO CONTENT JS
  $('.rm-content-text').click(function(e) {
    e.preventDefault();
    $('.rm-content_wrapper').toggleClass('active');
    if ($('.rm-content-text').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });

});

// let $preview = $('.byob-preview');
// if ($preview.length) {
//     let observer = new IntersectionObserver(function(entries) {
//         let entry = entries[0];

//         if (entry.isIntersecting) {
//             $preview.removeClass('sticky');
//         } else {
//             $preview.addClass('sticky');
//         }
//     }, {
//         threshold: 0
//     });

//     observer.observe($preview[0]);
// }


// const lightbox = document.querySelector('#lightbox');
// const lightboxImage = lightbox.querySelector('img');
// const lightboxCloseButton = lightbox.querySelector('#lightbox-close-button');

// lightbox.showLightbox = (lightboxLink) => {
// 	const lightboxThumbnail = lightboxLink.querySelector('img');

// 	lightboxImage.src = lightboxLink.href;
// 	requestAnimationFrame(() => {
// 		lightboxImage.src = lightboxLink.href;
// 	});

// 	lightboxImage.srcset = '';
// 	lightboxImage.alt = '';

//   document.body.classList.add('lock-all');
// 	lightbox.showModal();		
// };

// document.body.addEventListener('click', event => {
// 	const lightboxLink = event.target.closest('.lightbox-link');
// 	if (lightboxLink) {
// 		event.preventDefault();
// 		lightbox.showLightbox(lightboxLink);
// 	}
	
// 	else if (lightbox.open && !event.target.closest('img')) {
//     document.body.classList.remove('lock-all');
// 		lightbox.close();
// 	}
// });

// const $lightbox = $('#lightbox');
// const $lightboxImage1 = $('#lightbox-img-1');
// const $lightboxImage2 = $('#lightbox-img-2');
// const $closeButton = $('#lightbox-close-button');


// function showLightbox($link) {
//   const img1 = $link.attr('href');
//   const img2 = $link.attr('href-2');

//   $lightboxImage1.attr('src', img1);

//   if (img2) {
//     $lightboxImage2.attr('src', img2).show();
//   } else {
//     $lightboxImage2.attr('src', '').hide();
//   }

//   $('body').addClass('lock-all');
//   $lightbox[0].showModal();
// }

// function resetLightboxImages() {
//   $lightboxImage1.attr('src', '');
//   $lightboxImage2.attr('src', '');
// }

// $(document).on('click', '.lightbox-link', function (e) {
//   e.preventDefault();
//   showLightbox($(this));
// });

// $(document).on('click', function (e) {
//   if (
//     $lightbox[0].open &&
//     !$(e.target).closest('#lightbox-img-1, #lightbox-img-2, .lightbox-link').length
//   ) {
//     $('body').removeClass('lock-all');
//     $lightbox[0].close();
//     resetLightboxImages();
//   }
// });

// $closeButton.on('click', function () {
//   $('body').removeClass('lock-all');
//   $lightbox[0].close();
//   resetLightboxImages();
// });



$('body').on('click', '.lightbox-link', function(e){
  e.preventDefault();
  $('body').addClass('lock-all');
  $(this).parents('.product-item').find('.lightbox').attr('open', true);
});

$('body').on('click', '.lightbox-close-button', function(e){
  e.preventDefault();
  $('body').removeClass('lock-all');
  $(this).parents('.lightbox').attr('open', false);
});

$(document).ready(function () {
  $('.cart--announcementbar-list').slick({
    vertical: true,
    verticalSwiping: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true
  });

  function toggleHeader() {
    if ($(window).scrollTop() > 40) {
      $('.header-bottommenu').addClass('hide');
    } else {
      $('.header-bottommenu').removeClass('hide');
    }
  }

  // run on load
  toggleHeader();

  // run on scroll
  $(window).on('scroll', toggleHeader);

  if($('.announcement-bar__item-timer').length){
    const demo = document.getElementById('ann-demo');
    if (demo) {  
      // Only end date
      const endDate = new Date(demo.getAttribute('data-end')).getTime();
      const wrapper = demo.closest('.announcement-bar__item-timer');
      const x = setInterval(function () {
        const now = new Date().getTime();
        // Timer End
        if (now >= endDate) {
          clearInterval(x);
          if (wrapper) {
            wrapper.classList.add('removed');
          }
          return;
        }
        // Show timer
        if (wrapper) {
          wrapper.classList.remove('removed');
        }
        // Remaining time
        const distance = endDate - now;
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (distance % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor(
          (distance % (1000 * 60)) / 1000
        );
        let timerHTML = '';
        // Show days only if greater than 0
        if (days > 0) {
          const daytext = days === 1 ? 'Day' : 'Days';
          timerHTML += `${days}${daytext} : `;
        }
        timerHTML += `${hours}Hrs : ${minutes}Min : ${seconds}Sec`;
        demo.innerHTML = timerHTML;
      }, 1000);
    }
  }

  if($('.timer-section').length){
    const demo = document.getElementById('timer-section-demo');
    console.log('wwwwwwwwwwwww')
    if (demo) {  
      console.log('dddddddddddd')
        // Only end date
        const endDate = new Date(demo.getAttribute('data-end')).getTime();
        const wrapper = demo.closest('.timer-section');
        const x = setInterval(function () {
        const now = new Date().getTime();
        // Timer End
        if (now >= endDate) {
            clearInterval(x);
            if (wrapper) {
            wrapper.classList.add('removed');
            }
            return;
        }
        // Show timer
        if (wrapper) {
            wrapper.classList.remove('removed');
        }
        // Remaining time
        const distance = endDate - now;
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
            (distance % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor(
            (distance % (1000 * 60)) / 1000
        );
        let timerHTML = '';
        // Show days only if greater than 0
        if (days > 0) {
            const daytext = days === 1 ? 'Day' : 'Days';
            timerHTML += `${days}${daytext} : `;
        }
        timerHTML += `${hours}Hrs : ${minutes}Min : ${seconds}Sec`;
        demo.innerHTML = timerHTML;
        }, 1000);
    }
  }

  $('body').on('click', '.mini-cart-footer-total', function() {
    $(this).toggleClass('active');
    $(this).closest('.mini-cart__drawer-footer').find('.cart-payment-summary_main').slideToggle();
  });

  $("body").on("click", ".product-meta-dicount-btn", function () {
    var copy_text = $(this);
    var text = $(this).attr('data-code');
    var $temp = $("<input>");

    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    copy_text.html("Copied");
    setTimeout(function () {
      copy_text.html("Copy");
    }, 1000);
  });

});

if($('.cart--announcementbar-item-time').length){
  $(window).on('load', function () {
    setInterval(() => {
    const demo = document.querySelector('.cart-demo');
    if (demo) {      
      // Only end date
      const endDate = new Date(demo.getAttribute('data-end')).getTime();
      const wrapper = demo.closest('.cart--announcementbar-item-time');
      const x = setInterval(function () {
        const now = new Date().getTime();
        // Timer End
        if (now >= endDate) {
          clearInterval(x);
          if (wrapper) {
            wrapper.classList.add('removed');
          }
          return;
        }
        // Show timer
        if (wrapper) {
          wrapper.classList.remove('removed');
        }
        // Remaining time
        const distance = endDate - now;
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (distance % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor(
          (distance % (1000 * 60)) / 1000
        );
        let timerHTML = '';
        // Show days only if greater than 0
        if (days > 0) {
          const daytext = days === 1 ? 'Day' : 'Days';
          timerHTML += `${days}${daytext} : `;
        }
        timerHTML += `${hours}Hrs : ${minutes}Min : ${seconds}Sec`;
        demo.innerHTML = timerHTML;
      }, 1000);
    }
    }, 1000);
  })
}

// function initCartAnnouncementSlider() {
//   const $slider = $('.cart--announcementbar-list');

//   if ($slider.length) {

//     // Remove old slick if already initialized
//     if ($slider.hasClass('slick-initialized')) {
//       $slider.slick('unslick');
//     }

//     // Init slick
//     $slider.slick({
//       vertical: true,
//       verticalSwiping: true,
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       autoplay: true
//     });
//   }
// }

// // Initial page load
// $(document).ready(function () {
//   setTimeout(function () {
//     initCartAnnouncementSlider();
//   }, 2000);
// });
// // Cart Refresh
// document.addEventListener('cart:refresh', function () {
//   setTimeout(() => {
//     initCartAnnouncementSlider();
//   }, 1000);

// });

document.addEventListener('cart:refresh', function(event) {
   console.log("bbbbbbbbbbbbb")
   setInterval(() => {
    var $target = $('.cart--announcementbar-list');
    if($target.length > 0 && !$target.hasClass('slick-initialized')){
      console.log('page loaded');
          $target.slick({
            vertical: true,
            verticalSwiping: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true
          });
      }
    }, 2000);
})

$(window).on('load', function () {
  setInterval(() => {
  var $targett = $('.cart--announcementbar-list');
  if($targett.length > 0 && !$targett.hasClass('slick-initialized')){
    console.log('page loaded');    
      $targett.slick({
        vertical: true,
        verticalSwiping: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true
      });    
    }
  }, 2000);
})



// $('body').on('change', '.custom_filter_wp .fill_values input[type="checkbox"]', function(e) {

//   var _this = $(this);
//   var href = $(this).attr('name');
//   var val = $(this).attr('value');

//   if (val != undefined && val != '') {
//     if (val.indexOf(' ') >= 0) {
//       val = val.replaceAll(' ', '+');
//     }

//     var currentURL = window.location.href;
//     var finalVAL = href + '=' + val;
//     var is_current = false;
//     var without_cur = [];
//     var params = {};
//     var parser = document.createElement('a');
//     parser.href = window.location.href;
//     var query = parser.search.substring(1);
//     var vars = query.split('&');

//     for (var i = 0; i < vars.length; i++) {
//       var pair = vars[i].split('=');
//       if (encodeURI(href) == pair[0] && val == pair[1]) {
//         is_current = true;
//       } else {
//         if (_this.closest('.custom_filter_wp').hasClass('single_value')) {
//           if (encodeURI(href) == pair[0]) {
//             without_cur.push(pair[0] + '=' + val);
//           } else {
//             without_cur.push(pair[0] + '=' + pair[1]);
//           }
//         } else {
//           without_cur.push(pair[0] + '=' + pair[1]);
//         }
//       }
//     }

//     if (is_current) {
//       currentURL = (currentURL.indexOf('?') > -1) ? currentURL.split('?')[0] : currentURL;
//       if (without_cur.length > 0) {
//         currentURL = currentURL + '?' + without_cur.join('&');
//       } else {
//         currentURL = currentURL;
//       }
//     } else {
//       if (_this.closest('.custom_filter_wp').hasClass('single_value') && currentURL.indexOf(href) > -1) {
//         var newurl = [];
//         currentURL = (currentURL.indexOf('?') > -1) ? currentURL.split('?')[0] : currentURL;
//         for (var i = 0; i < vars.length; i++) {
//           var pair = vars[i].split('=');
//           if (encodeURI(href) == pair[0]) {
//             newurl.push(finalVAL);
//           } else {
//             newurl.push(pair[0] + '=' + pair[1]);
//           }
//         }
//         if (currentURL.indexOf('?') >= 0) {
//           currentURL = currentURL + '&' + newurl.join('&');
//         } else {
//           currentURL = currentURL + '?' + newurl.join('&');
//         }
//       } else {
//         if (currentURL.indexOf('?') >= 0) {
//           currentURL = currentURL + '&' + finalVAL;
//         } else {
//           currentURL = currentURL + '?' + finalVAL;
//         }
//       }
//     }

//     // ── Store popover ID before rerender destroys the reference ──
//     var $catFilter = _this.closest('[id^="category-filter-popover"]');
//     var catFilterId = $catFilter.length ? $catFilter.attr('id') : null;

//     // ── Dispatch on product-facet ──
//     var productFacet = document.querySelector('product-facet');
//     if (productFacet) {
//       productFacet.dispatchEvent(new CustomEvent('facet:criteria-changed', {
//         bubbles: true,
//         detail: { url: currentURL.toString() }
//       }));
//     }

//     // ── Re-open popover exactly when rerender finishes ──
//     if (catFilterId) {
//       var facetMain = document.querySelector('#facet-main');
//       if (facetMain) {
//         var observer = new MutationObserver(function() {
//           observer.disconnect();
//           var catFilterEl = document.getElementById(catFilterId);
//           if (catFilterEl) {
//             catFilterEl.open = true;
//           }
//         });
//         observer.observe(facetMain, { childList: true, subtree: false });
//       }
//     }
//   }
// });
document.addEventListener('DOMContentLoaded', () => {
  const carousel = document.querySelector('.product__media-list');
  if (!carousel) return;

  let startX = 0;
  let isSwiping = false;

  carousel.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    isSwiping = false;
  }, { passive: true });

  carousel.addEventListener('touchmove', (e) => {
    const diffX = Math.abs(e.touches[0].clientX - startX);

    if (diffX > 10 && !isSwiping) {
      isSwiping = true;
      // Pause video so touch event is freed for Flickity
      carousel.querySelectorAll('video').forEach(v => v.pause());
    }
  }, { passive: true });
});

/* ------------------------------------------------------------------
   Free claim items (cart drawer)
   Works with snippets/cart-free-claim.liquid. The drawer re-renders on
   every "cart:refresh" event, so all state (visibility, enabled state,
   messages) is server-rendered; this script only performs the cart
   mutations and triggers the refresh.
------------------------------------------------------------------- */
(() => {
  const dispatchCartRefresh = (cartContent) => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: cartContent ? { cart: cartContent, replacementDelay: 0 } : {}
    }));
  };

  const dispatchCartUpdated = (cartContent) => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
      bubbles: true,
      detail: { cart: cartContent }
    }));
  };

  class FreeClaimItems extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this._onClaimClick.bind(this));
      this._removeIneligibleItems();
    }

    async _onClaimClick(event) {
      const button = event.target.closest('[data-claim-add]');
      if (!button || button.disabled) return;
      button.disabled = true;
      button.setAttribute("aria-busy", true);
      $('[data-claim-add]').attr('disabled', true);
      // button.classList.add('free-claim__button--loading');
      try {
        await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: parseInt(button.getAttribute('data-variant-id'), 10),
            quantity: 1,
            properties: { _free_claim: button.getAttribute('data-claim-tier') }
          })
        });
      } catch (error) {
        console.error('Free claim: add failed', error);
      }
      // No cart payload passed: the drawer refetches its section and the
      // cart count refetches cart.js, so both stay accurate either way.
      dispatchCartRefresh();
    }

    // Claimed gifts whose threshold is no longer met (main items removed /
    // quantity decreased) are flagged by Liquid in data-remove-keys.
    async _removeIneligibleItems() {
      const keys = (this.getAttribute('data-remove-keys') || '').split(',').filter(Boolean);
      if (keys.length === 0) return;
      const updates = {};
      keys.forEach((key) => (updates[key] = 0));
      try {
        const response = await fetch(`${window.themeVariables.routes.cart_update_url}.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates, sections: ['mini-cart'] })
        });
        if (response.ok) {
          const cartContent = await response.json();
          dispatchCartUpdated(cartContent);
          dispatchCartRefresh(cartContent);
        }
      } catch (error) {
        console.error('Free claim: cleanup failed', error);
      }
    }
  }

  if (!window.customElements.get('free-claim-items')) {
    window.customElements.define('free-claim-items', FreeClaimItems);
  }

  // "Change" button on claimed line items: remove the gift so another one
  // can be picked from the claim section.
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-claim-change]');
    if (!button || button.disabled) return;
    event.preventDefault();
    button.disabled = true;
    try {
      const response = await fetch(`${window.themeVariables.routes.cartChangeUrl}.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: button.getAttribute('data-line-key'), quantity: 0, sections: ['mini-cart'] })
      });
      if (response.ok) {
        const cartContent = await response.json();
        dispatchCartUpdated(cartContent);
        dispatchCartRefresh(cartContent);
      } else {
        button.disabled = false;
      }
    } catch (error) {
      console.error('Free claim: change failed', error);
      button.disabled = false;
    }
  });
})();

// =============================================================================
$(function () {

  $('body').on('change', '.product-info--gift_product-input', function () {

    var $container = $('.product-meta__price-list-container');
    var $list = $container.find('.price-list');
    var currencyFormat = window.themeVariables.settings.moneyFormat;

    // original values — attributes are never rewritten, so always the originals
    var basePrice   = parseInt($list.attr('price')) || 0;
    var baseCompare = parseInt($list.attr('compare_at_price')) || 0;

    var $gift = $(this);

    // gift values (0 when unchecked)
    var giftPrice   = $gift.is(':checked') ? parseInt($gift.attr('price')) || 0 : 0;
    var giftCompare = $gift.is(':checked') ? parseInt($gift.attr('compare_at_price')) || giftPrice : 0;

    // originals + gift
    var price   = basePrice + giftPrice;
    var compare = baseCompare ? baseCompare + giftCompare : 0;

    var priceText   = formatMoney(price, currencyFormat);
    var compareText = compare ? formatMoney(compare, currencyFormat) : '';
    var discount    = compare > price ? Math.round((compare - price) / compare * 100) : 0;

    // inner content only — .price-list element and its attributes stay intact
    $list.html(`
      <span class="product-meta__mrp-price-text">mrp:</span>
      ${compare ? `<span class="price price--compare">
        <span class="visually-hidden">Regular price</span>${compareText}
      </span>` : ''}
      <span class="price price--highlight price--large">
        <span class="visually-hidden">Sale price</span>${priceText}
      </span>
    `);

    // sticky bar
    $('.product-sticky-form__price-list').html(`
      <span class="product-sticky-form__mrp-price-text">mrp:</span>
      ${compare ? `<span class="product-sticky-form-compare__price">${compareText}</span>` : ''}
      <span class="product-sticky-form__price">${priceText}</span>
      ${discount ? `<span class="product-sticky-form__save-percentage">(${discount}%)</span>` : ''}
    `);

  });

});

// =============================================================================
(function () {
  'use strict';

  if (window.customElements.get('mini-cart-before-claim')) return;

  class MiniCartBeforeClaim extends HTMLElement {
    connectedCallback() {
      this._onAddClick = this._onAddClick.bind(this);
      this.addEventListener('click', this._onAddClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onAddClick);
    }

    async _onAddClick(event) {
      const button = event.target.closest('[data-add-to-cart]');
      if (!button || button.disabled || !this.contains(button)) return;

      const variantId = parseInt(button.getAttribute('data-variant-id'), 10);
      if (!variantId) return;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }]
          })
        });

        if (!response.ok) throw new Error(await response.text());

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {}
        }));
      } catch (error) {
        console.error('Mini cart claim: add failed', error);
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
  }

  window.customElements.define('mini-cart-before-claim', MiniCartBeforeClaim);
})();